/**
 * UserInfo Component
 *
 * Displays user-related actions and diploma information in the course top section.
 * Uses Redux selectors to get course and user info from the store.
 * Passes relevant props to child components for dynamic rendering and state management.
 *
 * Features:
 * - Renders BtnShop for course purchase actions
 * - Renders ShowDiploma if all activities are completed and user info exists
 * - PropTypes and defaultProps for robust type checking
 *
 * @returns {JSX.Element} The rendered user info section
 */

import { useSelector } from 'react-redux';
import BtnShop from '../../BtnShop/BtnShop';
import ShowDiploma from '../../CourseSpecificInfo/ShowDiploma/ShowDiploma';

import classes from './UserInfo.module.css';

const UserInfo = () => {
  const dataCourse = useSelector(state => state.courseInfo);
  const userInfo = useSelector(state => state.userInfo);

  return (
    <>
      <div className={classes.buyContainer}>
        <aside className={classes.btnContainer}>
          <BtnShop />
          {dataCourse.missingActivities.length === 0 &&
            userInfo.data.usuario.length !== 0 && (
              <div className={classes.showDiplomacontainer}>
                <ShowDiploma
                  dataCertificate={dataCourse.userDegree} // Prop passed: diploma data
                  titleCourse={dataCourse.data.nombre} // Prop passed: course title
                />
              </div>
            )}
        </aside>
      </div>
    </>
  );
};

UserInfo.propTypes = {};
UserInfo.defaultProps = {};

export default UserInfo;
